
export default function About() {
  return (
    <section id="about" className="relative bg-[#faf9f6] py-32 px-20">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12">
          <span className="text-sm text-[#8b7d6b] font-light">/about</span>
        </div>
        
        <div className="grid grid-cols-2 gap-20 items-center">
          <div>
            <p className="text-5xl font-thin text-[#2d2a26] leading-relaxed">
              We are a dedicated team of experts specializing in developing modern applications for the iOS platform
            </p>
          </div>
          
          <div className="space-y-6">
            <p className="text-lg text-[#6b7280] leading-relaxed">
              Our mission is to create innovative mobile solutions that enhance user experience and improve the security of mobile devices. With years of expertise in iOS development, we focus on delivering high-quality applications that meet the evolving needs of modern users.
            </p>
            <p className="text-lg text-[#6b7280] leading-relaxed">
              From VPN solutions that protect your privacy to cleaning tools that optimize device performance, every product we create is built with precision, care, and a deep understanding of user needs.
            </p>
          </div>
        </div>

        <div className="mt-20 flex items-center gap-6">
          <div className="flex items-center gap-2">
            <div className="w-12 h-12 rounded-full bg-[#2d2a26] flex items-center justify-center">
              <i className="ri-user-line text-white text-xl"></i>
            </div>
            <div className="w-12 h-12 rounded-full bg-[#3d3a36] flex items-center justify-center">
              <i className="ri-user-line text-white text-xl"></i>
            </div>
            <div className="w-12 h-12 rounded-full bg-[#4d4a46] flex items-center justify-center">
              <i className="ri-user-line text-white text-xl"></i>
            </div>
            <div className="w-12 h-12 rounded-full bg-[#5d5a56] flex items-center justify-center">
              <i className="ri-user-line text-white text-xl"></i>
            </div>
          </div>
          <span className="text-base text-[#6b7280]">Our Development Team</span>
        </div>

        <div className="mt-8">
          <span className="text-sm text-[#b0b0b0]">Expert Team</span>
        </div>
      </div>
    </section>
  );
}
